import React, {Component} from 'react';
import {Helmet} from 'react-helmet';

// Assets
import DownArrow from '../assets/symbols/downarrow.svg';

// Components
import Calendly from '../components/Calendly';
import Footer from '../components/Footer';
import Modal from '../components/Modal';
import Navbar from '../components/Navbar';
import Testimonial from '../components/Testimonial';

class SpeakersBureau extends Component {

    state = {
        showModal: "none",
        displayMobile: "none"
      }
    
      toggleModal = () => {
        if (this.state.showModal === "none") {
            this.setState({
              showModal: "block"
            })
            window.scrollTo(0,0);
        }
        else {
            this.setState({
              showModal: "none"
            })
        }
      }

      toggleMobileMenu = () => {
        if (this.state.displayMobile === "none") {
            this.setState({
              displayMobile: "flex"
            })
        }
        else {
            this.setState({
              displayMobile: "none"
            })
        }
      }

      scrollDown = () => {
          document.getElementById("Testimonial").scrollIntoView({ block: "start", inline: "nearest", behavior: "smooth"});
      }

    render() {
        return(
            <div className="SpeakerBureau">
                <Helmet>
                    <title>Custom Web and Tech Solutions for Speakers Bureaus | Candid Goat</title>
                    <meta name="description" content="Candid Goat builds custom speakers bureau websites that generate new leads, increase revenue, and create amazing customer experiences for meeting owners." />
                </Helmet>
                <Modal click={this.toggleModal} showModal={this.state.showModal} />
                <Navbar click={this.toggleModal} displayMobile={this.state.displayMobile} mobileMenu={this.toggleMobileMenu} />
                <div className="speakerBureauHero centerText">
                    <div className="container width-12 speakerBureauContent">
                        <h1 className="heroFont">Take Your Business Higher</h1>
                        <h2 className="bodyFont">Custom websites that create new leads, more revenue, and amazing customer experiences</h2>
                    </div>
                    <button onClick={()=>{this.scrollDown()}}><img src={DownArrow} alt="Down Arrow"/></button>
                    <Testimonial content='"Becky Sue Wehry’s vision and oversight of our website renovation more than doubled our traffic, increased our page views 5X, generated hundreds of new leads of impressive quality, and contributed to a significant amount in new business sales. She also streamlined our internal operations, redesigned marketing materials, served up wise suggestions and was artful in her pushbacks. She’s a wonderful person to work with."' name="Brian Palmer" title="CMM, National Speakers Bureau"/>
                </div>
                <Calendly />
                <Footer />
            </div>
        )
    }
}

export default SpeakersBureau;


// WEBPACK FOOTER //
// ./src/pages/SpeakersBureau.js